import * as React from "react";
import styled, { css } from "styled-components";
import Badge from "components/bootstrap/Badge";
const StyledBadge = styled(Badge)(
  ({ theme }) => css`
    background-color: ${theme.colors.variant.light.danger};
  `
);
const BetaBadge = () => /* @__PURE__ */ React.createElement(StyledBadge, null, "Beta");
export default BetaBadge;
